export const validateNumber = (number) => {
  if (number === "" || isNaN(number) || number < 0) return false;
  return true;
};

export const validateNumberInput = (number) => {
  if (isNaN(number) || number < 0) return false;
  return true;
};

export const validateDays = (days) => {
  if (isNaN(days) || days < 0 || days > 365) return false;
  return true;
};

export const validatePercentage = (percentage) => {
  if (
    percentage === "" ||
    isNaN(percentage) ||
    percentage < 0 ||
    percentage > 100
  )
    return false;
  return true;
};

export const validatePercentageInput = (percentage) => {
  if (isNaN(percentage) || percentage < 0 || percentage > 100) return false;
  return true;
};

export const validateString = (string) => {
  if (string === "") return false;
  return true;
};

export const validateRatio = (value) => {
  const allowedCharacters = /^[0-9:]*$/;
  // if (!allowedCharacters.test(value)) return;

  // Validate ratio or number formats
  const isNumber = /^\d+$/; // Matches only numbers like "123"
  const isPartialRatio = /^\d+:\d*$/; // Matches "1:", "1:2", or "12:34"
  if (
    value !== "" &&
    (!allowedCharacters.test(value) ||
      !(isNumber.test(value) || isPartialRatio.test(value)))
  )
    return false;
  return true;
};

export const validateDates = ({ startDate, endDate, newErrors, isValid }) => {
  const today = new Date(); // Get the current date

  // Ensure that startDate and endDate are not greater than today's date
  if (startDate && startDate > today) {
    newErrors.Date = "Start date cannot be in the future";
    isValid = false;
  }

  if (endDate && endDate > today) {
    newErrors.Date = "End date cannot be in the future";
    isValid = false;
  }

  // Ensure that the startDate is less than or equal to the endDate
  if (startDate && endDate && startDate >= endDate) {
    newErrors.Date = "End date must be greater than Start date";
    isValid = false;
  }
  return { newErrors, isValid };
};

/** YYYY-MM-DD for `<input type="date" max>` (local calendar day, not UTC). */
export function todayLocalYYYYMMDD() {
  const t = new Date();
  const y = t.getFullYear();
  const m = String(t.getMonth() + 1).padStart(2, "0");
  const d = String(t.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export const PURCHASE_DATE_MIN = "2013-01-01";

const PURCHASE_DATE_RANGE_MESSAGE =
  "Purchase date must be between 01-01-2013 and today.";

/** Returns error message if purchase date is outside [PURCHASE_DATE_MIN, today], else null. */
export function getPurchaseDateRangeError(raw) {
  if (!raw) return null;
  let s = String(raw).trim();
  if (s.includes("T")) s = s.split("T")[0];
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  if (!match) {
    return PURCHASE_DATE_RANGE_MESSAGE;
  }
  const y = Number(match[1]);
  const mo = Number(match[2]) - 1;
  const d = Number(match[3]);
  const selected = new Date(y, mo, d);
  if (
    Number.isNaN(selected.getTime()) ||
    selected.getFullYear() !== y ||
    selected.getMonth() !== mo ||
    selected.getDate() !== d
  ) {
    return PURCHASE_DATE_RANGE_MESSAGE;
  }
  const minParts = PURCHASE_DATE_MIN.split("-").map(Number);
  const min = new Date(minParts[0], minParts[1] - 1, minParts[2]);
  const todayEnd = new Date();
  todayEnd.setHours(23, 59, 59, 999);
  if (selected < min || selected > todayEnd) {
    return PURCHASE_DATE_RANGE_MESSAGE;
  }
  return null;
}
